import React from "react";
import { Handle, Position } from "reactflow";
import { BarsOutlined } from "@ant-design/icons";

import { useFlowNodes } from "../../../context";
import { ButtonDelete } from "../../ButtonDelete";
import Responses from "components/Accordion/AccordionIntents/outputs/responses";
import { handleDeleteResponses } from "../../utils/removeDataNode";

import "./ResponsePhrasesIntentNode.scss";

export const ResponsePhrasesIntentNode = ({ id }) => {
  const { t, setNodes, setEdges, ...res } = useFlowNodes();

  return (
    <>
      <div className="respons-node">
        <Handle type="target" position={Position.Left} />
        <Handle type="source" id={id} position={Position.Right} />
        <div className="respons-header">
          <div className="respons-title-wrapper">
            <div className="respons-icon">
              <BarsOutlined />
            </div>
            <span className="respons-name">
              {t("common:intents.flow_chat.response.title")}
            </span>
          </div>
          <div className="respons-delete-button">
            <ButtonDelete
              setNodes={setNodes}
              setEdges={setEdges}
              nodeId={id}
              handleDelete={() => handleDeleteResponses(res.updateIntent)}
            />
          </div>
        </div>
        <div className={"accordion__content"} style={{ marginTop: "10px" }}>
          <Responses {...res} type="responses" isFlow={true} />
        </div>
      </div>
    </>
  );
};
